var path = 'app/scripts/modules/titus/src/serverGroup/details/scalingPolicy/alarmBasedSummary.template.html';
var html = "<titus-alarm-based-summary\n  policy=\"$ctrl.policy\"\n  server-group=\"$ctrl.serverGroup\"\n  application=\"$ctrl.application\"\n></titus-alarm-based-summary>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;